// B2CBlogsPage.tsx
import { Box, Heading, VStack, Text, SimpleGrid, useColorModeValue,AspectRatio } from "@chakra-ui/react";
import PublicLayout from "./Layouts/PublicLayout";
import { useNavigate } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import bandpic from "../../resources/EDUVIC B2C Hero3.png";

interface Blog {
  blog_id: number;
  title: string;
  slug: string;
  description?: string;
  card_image_key?: string;
  author_name?: string;
  published_at?: string;
}

const markdownComponents = {
  p: ({ children }: any) => <Text noOfLines={3} fontSize="sm" color="gray.600">{children}</Text>,
};

const B2CBlogsPage = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  const fetchBlogs = useCallback(async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "https://default-url.com";
      const response = await axios.get(`${apiUrl}/b2c/public/blogs`);
      setBlogs(response.data);
    } catch (error) {
      console.error("Failed to load blogs", error);
    }
  }, []);

  useEffect(() => { fetchBlogs(); }, [fetchBlogs]);

  return (
    <PublicLayout>
{/* ================= BLOGS HERO ================= */}

{/* ================= BLOGS HERO ================= */}

  <Box
    as="section"
    minH={{ base: "260px", md: "320px" }}
    bgImage={bandpic}
    bgSize="cover"
    // Mobile crops from the left side of the source image instead of
    // the right, so the logo/figure moves out of the text's way.
    // Desktop/tablet unchanged.
    bgPosition={{ base: "left center", md: "right center" }}
    bgRepeat="no-repeat"
    position="relative"
    overflow="hidden"
  >
  {/* LEFT Gradient Overlay for readability */}
  <Box
    position="absolute"
    top="0"
    left="0"
    width="100%"
    height="100%"
    bgGradient="
      linear(
        to-r,
        rgba(0,0,0,0.68),
        rgba(0,0,0,0.35),
        rgba(0,0,0,0)
      )
    "
    zIndex={1}
  />

  {/* Content */}
  <Box
    position="relative"
    zIndex={2}
    minH={{ base: "260px", md: "320px" }}
    display="flex"
    alignItems="center"
    px={{ base: 6, md: 16 }}
  >
    <VStack
      align="flex-start"
      spacing={4}
      maxW="700px"
    >

      <Heading
        color="white"
        size="2xl"
        lineHeight="1.2"
      >
        Eduvic Blogs
      </Heading>

      <Text
        color="gray.100"
        fontSize={{ base: "md", md: "lg" }}
        lineHeight="1.7"
        maxW="650px"
      >
        Practical guides to Australian tests, exam formats and what to expect.
      </Text>

    </VStack>
  </Box>
</Box>


      <Box py={12} px={6}>
        <VStack spacing={10}>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8} maxW="1200px" mx="auto" width="100%">
            {blogs.map((blog) => (
              <Box
                key={blog.blog_id}
                bg={cardBg}
                borderWidth="1px"
                borderColor={borderColor}
                borderRadius="xl"
                overflow="hidden"
                cursor="pointer"
                transition="all 0.3s"
                h="100%"
                _hover={{ transform: "translateY(-6px)", boxShadow: "xl" }}
                onClick={() => navigate(`/practice/blog/${blog.slug}`)}
              >
                {blog.card_image_key && (
                  <AspectRatio ratio={16 / 9}>
                    <Box bgImage={blog.card_image_key} bgSize="cover" bgPosition="center" />
                  </AspectRatio>
                )}
                <Box p={5}>
                  <Heading size="md" mb={2} noOfLines={2}>{blog.title}</Heading>
                  {blog.description && (
                    <ReactMarkdown components={markdownComponents}>{blog.description}</ReactMarkdown>
                  )}
                  <Text fontSize="xs" color="gray.400" mt={3}>
                    {blog.author_name} {blog.published_at && `· ${new Date(blog.published_at).toLocaleDateString()}`}
                  </Text>
                </Box>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Box>
    </PublicLayout>
  );
};

export default B2CBlogsPage;